module.exports = __webpack_public_path__ + "static/media/HOME-image5.5f345742.png";